export default "__VITE_ASSET__2ohHMnuH__"